<template>
	<n-tooltip class="text-fs-xs! px-1.5! py-1!">
		<template #trigger>
			<n-tag :round :color="{ color: 'transparent' }" :size class="text-fs-sm font-normal">
				<template v-if="icon" #icon>
					<Icon :name="icon" :size="sizePX" />
				</template>
				<span v-html="label"></span>
			</n-tag>
		</template>
		{{ $t(`patients.tags.gestational_age`) }}
	</n-tooltip>
</template>

<script setup lang="ts">
import type { PatientMeta } from "@/types/patient"
import { NTag, NTooltip } from "naive-ui"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import Icon from "@/components/common/Icon.vue"
import { ICONS } from "@/const"
import { getGestationalLabel } from "@/utils/pregnancyCalculator"

const { meta, size } = defineProps<{
	meta: PatientMeta
	round?: boolean
	size?: "small" | "medium" | "large" | "tiny"
}>()

const { t } = useI18n()

const sizePX = computed(() => (size === "small" ? 12 : size === "large" ? 16 : size === "tiny" ? 10 : 14))

const label = computed(() =>
	getGestationalLabel(meta.gestational_period || { weeks: 0, days: 0 }, { t, useHtml: true })
)

const icon = computed(() => ICONS.gestational_period)
</script>
